module.exports = __webpack_public_path__ + "static/media/side-view.04020df2.jpg";